import { provideRouter, Routes, withInMemoryScrolling, withViewTransitions } from '@angular/router';
import { IndexComponent } from './view/index/index.component';
import { SubmitComponent } from './view/script/submit/submit.component';
import { UsersComponent } from './view/admin/users/users.component';
import { IndexComponent as AdminIndexComponent } from './view/admin/index/index.component';
import { PatreonComponent } from './view/patreon/patreon.component';
import { CreationsComponent } from './view/script/creations/creations.component';
import { LoginComponent } from './view/login/login.component';
import { ScriptsComponent } from './view/admin/scripts/scripts.component';
import { AdminScriptReviewComponent } from './view/admin/scripts/admin-script-review/admin-script-review.component';
import { AdminGamenightComponent } from './view/admin/gamenight/gamenight.component';
import { AdminStatsComponent } from './view/admin/stats/stats.component';
import { KnowledgeBaseComponent } from './view/admin/knowledge-base/knowledge-base.component';
import { AdminSupportComponent } from './view/admin/support/support.component';
import { BugReportsComponent } from './view/admin/bug-reports/bug-reports.component';
import { HelpComponent } from './view/help/help.component';
import { ChatbotComponent } from './view/help/chatbot/chatbot.component';
import { GamenightComponent } from './view/gamenight/gamenight.component';
import { AccountSettingsComponent } from './view/account-settings/account-settings.component';
import { EventsComponent } from './view/events/events.component';
import { TutorialComponent } from './view/script/tutorial/tutorial.component';
import { CreditsComponent } from './view/credits/credits.component';
import { NotificationsComponent } from './view/notifications/notifications.component';
import { YourDataComponent } from './view/your-data/your-data.component';
import { PerformanceComponent } from './view/admin/performance/performance.component';
import { ErrorsComponent } from './view/admin/errors/errors.component';
import { SunsetInfoComponent } from './view/script/sunset-info/sunset-info.component';
import { PrivacyComponent } from './view/privacy/privacy.component';

export const routes: Routes = [
    {path: 'scripts/sunsetting-info', component: SunsetInfoComponent},
    {path: 'scripts/submit', component: SubmitComponent},
    {path: 'scripts/submit/example', component: SubmitComponent, data: { readonly: true, example: true }},
    {path: 'scripts/submit/:script_id', component: SubmitComponent},
    {path: 'scripts/submit/:script_id/:version_id', component: SubmitComponent},
    {path: 'scripts/tutorial', component: TutorialComponent},
    {path: 'scripts/creations', component: CreationsComponent},
    {path: 'scripts', component: CreationsComponent},
    {path: 'patreon', component: PatreonComponent},
    {path: 'admin', component: AdminIndexComponent},
    {path: 'admin/users', component: UsersComponent},
    {path: 'admin/scripts', component: ScriptsComponent},
    {path: 'admin/scripts/:script_id', component: AdminScriptReviewComponent},
    {path: 'admin/scripts/:script_id/:version', component: AdminScriptReviewComponent},
    {path: 'admin/gamenight', component: AdminGamenightComponent},
    {path: 'admin/stats', component: AdminStatsComponent},
    {path: 'admin/performance', component: PerformanceComponent},
    {path: 'admin/knowledge_base', component: KnowledgeBaseComponent},
    {path: 'admin/bug_reports', component: BugReportsComponent},
    {path: 'admin/support/:userID', component: AdminSupportComponent},
    {path: 'admin/errors', component: ErrorsComponent},
    {path: 'login', component: LoginComponent},
    {path: 'help', component: HelpComponent},
    {path: 'help/chatbot', component: ChatbotComponent},
    {path: 'gamenight', component: GamenightComponent},
    {path: 'account', component: AccountSettingsComponent},
    {path: 'notifications', component: NotificationsComponent},
    {path: "events", component: EventsComponent},
    {path: "credits", component: CreditsComponent},
    {path: "your-data", component: YourDataComponent},
    {path: "privacy", component: PrivacyComponent},

    // Redirects
    {path: 'account/connections', redirectTo: 'patreon'},
    {path: 'assets/audience_anarchy_tutorial.html', redirectTo: 'scripts/tutorial'},
    

    {path: '', component: IndexComponent}
]; // Todo: Add redirects to make old links work

export const routerConfig = provideRouter(
    routes,
    withViewTransitions(
        {
            skipInitialTransition: true
        }
    ),
    withInMemoryScrolling({
        scrollPositionRestoration: 'top'
    })
);